<template>
	<div class="banner-split2-support-team">
		<b-row class="banner">
			<b-col class="col-lg-6 col-sm-12 col-12 left banner-item">
				<Slider :data="sliderData"></Slider>
			</b-col>
			<b-col class="col-lg-6 col-sm-12 col-12 right banner-item">
				<h3 class="title">超偶特攻隊</h3>
				<p class="content">
					你充滿活力、熱情嗎？你對於表演藝術充滿喜愛與期待嗎？讓我們提起一卡小皮箱，一同加入偶戲天地的志工行列，與我們攜手打造最親切又專業的國際偶戲藝術村服務…，來吧！讓我們一起玩！邀請你成為利澤國際偶戲藝術村的重要推手！
				</p>
				<h3 class="title">Volunteers</h3>
				<p class="content">
					If you have an interest in puppetry or have a passion for performing art, welcome to join in Lize Puppet Art Colony Family to promote puppetry together. Please sign up the application form below or contact us via E-mail: lize.puppet@gmail.com
				</p>
			</b-col>
		</b-row>

	</div>
</template>

<script>
import Slider from '@/components/slider'
export default {
  name: "bannerSplit2SupportTeam",
  data() {
    return {
      sliderData: [
        "/static/assets/support/team/img_01.png",
      ]
    };
  },
  methods: {

  },
  props: {
    ch: String,
    en: String
  },
  components: {
    Slider
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .banner-split2-support-team
    text-align: justify
    overflow: hidden
    .banner
      .banner-item
        min-height: 480px
        height: 471px
        @media screen and (max-width: 1000px)
          height: initial
          min-height: 300px
      .left
        padding: 0
      .right
        background-color: $themeGray
        color: $white
        padding: 45px
        overflow-y: auto
        font-weight: 300
        .title
          font-size: $font-size-3
          margin: 20px 0
        .content
          font-size: $font-size-3-s
          line-height: 2
        .club-pic
          +size(318px, auto)


</style>



// WEBPACK FOOTER //
// src/components/banner/banner_split2_support_team.vue